(function () {
  if (window.AnnaBSizeColorPinsCorrectInit) return;
  window.AnnaBSizeColorPinsCorrectInit = true;

  function normalize(value) {
    if (!value) return "";

    return value
      .toString()
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function cleanLabelText(text) {
    return normalize(text)
      .replace(/-\d+$/, "")
      .replace(/-\d+-articoli$/, "")
      .replace(/-\d+-prodotti$/, "")
      .replace(/-articoli$/, "")
      .replace(/-prodotti$/, "");
  }

  function getFilters() {
    var selectedSize = "";
    var selectedColors = [];

    var params = new URLSearchParams(window.location.search);

    params.forEach(function (value, key) {
      var normalizedKey = normalize(key);

      if (
        normalizedKey.includes("taglia") ||
        normalizedKey.includes("size")
      ) {
        selectedSize = normalize(value);
      }
    });

    document
      .querySelectorAll('input[name^="filter."]:checked')
      .forEach(function (input) {
        var inputName = normalize(input.name);
        var inputValue = normalize(input.value || "");
        var label = input.closest("label");
        var labelText = "";

        if (label) {
          var textElement =
            label.querySelector(".facet-label-text") ||
            label.querySelector(".checkbox__label-text") ||
            label.querySelector("span:last-child");

          labelText = cleanLabelText(
            textElement
              ? textElement.textContent
              : label.textContent
          );
        }

        if (
          inputName.includes("taglia") ||
          inputName.includes("size")
        ) {
          selectedSize = inputValue || labelText;
        }

        if (
          inputName.includes("colore") ||
          inputName.includes("color")
        ) {
          /*
           * Il value del filtro colore può essere un GID Shopify.
           * Per questo prendiamo prima il nome visibile del colore.
           */
          var selectedColor = labelText || inputValue;

          if (
            selectedColor &&
            !selectedColors.includes(selectedColor)
          ) {
            selectedColors.push(selectedColor);
          }
        }
      });

    return {
      size: normalize(selectedSize),
      colors: selectedColors.map(normalize).filter(Boolean)
    };
  }

  /*
   * ANNAB INP: le varianti venivano riparsate da JSON a ogni chiamata, e
   * getProductData viene invocata una volta per card sia in applyPinsFilter
   * sia in updateColorFacetCounts. Su una collection da 50 prodotti erano
   * un centinaio di JSON.parse per esecuzione, sul thread principale, in
   * risposta al tocco dell'utente.
   *
   * La WeakMap è indicizzata sull'elemento: quando Shopify rigenera la griglia
   * dopo un filtro, le card vecchie vengono raccolte dal garbage collector e
   * la cache si svuota da sola.
   */
  var annabProductDataCache = new WeakMap();

  function getProductData(card) {
    if (annabProductDataCache.has(card)) {
      return annabProductDataCache.get(card);
    }

    var jsonElement = card.querySelector(
      ".annab-card-gallery-data"
    );

    if (!jsonElement) {
      annabProductDataCache.set(card, null);
      return null;
    }

    var parsed = null;

    try {
      parsed = JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.warn(
        "AnnaB: impossibile leggere le varianti della card",
        error
      );
    }

    annabProductDataCache.set(card, parsed);

    return parsed;
  }

  function getOptionIndexes(productData) {
    var sizeIndex = -1;
    var colorIndex = -1;

    productData.option_names.forEach(function (
      optionName,
      index
    ) {
      var normalizedName = normalize(optionName);

      if (
        normalizedName.includes("taglia") ||
        normalizedName.includes("size")
      ) {
        sizeIndex = index;
      }

      if (
        normalizedName.includes("colore") ||
        normalizedName.includes("color")
      ) {
        colorIndex = index;
      }
    });

    return {
      size: sizeIndex,
      color: colorIndex
    };
  }

  function getMainCardImage(card) {
    return (
      card.querySelector(".card-gallery img") ||
      card.querySelector(".js-product-card-gallery img") ||
      card.querySelector(".product-card__media img") ||
      card.querySelector(".product-card__image img") ||
      card.querySelector(".card-media img") ||
      card.querySelector(".card__media img") ||
      card.querySelector("picture img") ||
      card.querySelector(".product-grid__card img") ||
      card.querySelector(".product-card__content img") ||
      card.querySelector("img")
    );
  }

  function setCardImage(card, imageUrl) {
    if (!card || !imageUrl) return;

    var image = getMainCardImage(card);
    if (!image) return;

    image.src = imageUrl;
    image.setAttribute("src", imageUrl);
    image.setAttribute("data-src", imageUrl);
    image.setAttribute(
  "srcset",
  [320, 480, 640, 900, 1200]
    .map(function (width) {
      try {
        var url = new URL(imageUrl, window.location.origin);
        url.searchParams.set("width", width);
        return url.href + " " + width + "w";
      } catch (e) {
        var separator = imageUrl.indexOf("?") !== -1 ? "&" : "?";
        return imageUrl + separator + "width=" + width + " " + width + "w";
      }
    })
    .join(", ")
);

    var picture = image.closest("picture");

    if (picture) {
      picture
        .querySelectorAll("source")
        .forEach(function (source) {
          source.setAttribute("srcset", imageUrl);
        });
    }

    var gallery = card.querySelector(
      ".js-product-card-gallery, .card-gallery"
    );

    if (gallery) {
      gallery.setAttribute("data-media-url", imageUrl);
    }

    var cardLinkWrapper = card.closest(
      "product-card-link"
    );

    if (cardLinkWrapper) {
      cardLinkWrapper.setAttribute(
        "data-featured-media-url",
        imageUrl
      );
    }
  }

  function setExactVariantUrl(swatch, variant) {
    if (!swatch || !variant) return;

    var variantUrl = variant.url || "";

    if (!variantUrl) {
      var originalUrl =
        swatch.getAttribute("data-variant-url") || "";

      if (originalUrl) {
        try {
          var parsedUrl = new URL(
            originalUrl,
            window.location.origin
          );

          parsedUrl.searchParams.set(
            "variant",
            variant.id
          );

          variantUrl =
            parsedUrl.pathname +
            parsedUrl.search;
        } catch (error) {
          variantUrl = originalUrl;
        }
      }
    }

    if (variantUrl) {
      swatch.setAttribute(
        "data-variant-url",
        variantUrl
      );
    }

    swatch.dataset.filteredVariantId =
      variant.id || "";
  }

  function activateFilteredSwatch(card, swatch) {
    if (!card || !swatch) return;

    card
      .querySelectorAll(".js-color-swatch")
      .forEach(function (button) {
        button.classList.remove("is-active");
      });

    swatch.classList.add("is-active");

    var variantUrl =
      swatch.getAttribute("data-variant-url") || "";

    var variantImage =
      swatch.getAttribute("data-variant-image") || "";

    var colorValue = normalize(
      swatch.getAttribute("data-color-handle") ||
      swatch.getAttribute("data-color-value") ||
      swatch.getAttribute("data-color-name")
    );

    card.dataset.selectedVariantUrl = variantUrl;
    card.dataset.selectedColorValue = colorValue;
    card.dataset.manualColorSelection = "true";
card.dataset.lockedVariantImage = variantImage;

    var mainLink = card.querySelector(
      ".js-product-card-main-link"
    );

    if (mainLink && variantUrl) {
      mainLink.setAttribute("href", variantUrl);
    }

    if (variantImage) {
      setCardImage(card, variantImage);
    }
  }

  function resetMoreButton(list) {
    var oldMore = list.querySelector(
      ".product-card-color-swatches__item--more"
    );

    if (oldMore) {
      oldMore.remove();
    }

    list.classList.remove("is-expanded");

    list
      .querySelectorAll(
        ".product-card-color-swatches__item"
      )
      .forEach(function (item) {
        item.classList.remove("is-hidden-swatch");
      });
  }

  function refreshSwatchMore() {
    document
      .querySelectorAll(
        ".product-card-color-swatches"
      )
      .forEach(function (list) {
        resetMoreButton(list);

        var availableItems = Array.from(
          list.querySelectorAll(
            ".product-card-color-swatches__item"
          )
        ).filter(function (item) {
          return (
            !item.classList.contains(
              "is-hidden-by-size"
            ) &&
            !item.classList.contains(
              "product-card-color-swatches__item--more"
            )
          );
        });

        var visibleCount = 3;

        if (availableItems.length <= visibleCount) {
          return;
        }

        var hiddenItems =
          availableItems.slice(visibleCount);

        hiddenItems.forEach(function (item) {
          item.classList.add("is-hidden-swatch");
        });

        var moreItem =
          document.createElement("li");

        moreItem.className =
          "product-card-color-swatches__item " +
          "product-card-color-swatches__item--more";

        var moreButton =
          document.createElement("button");

        moreButton.type = "button";
        moreButton.className =
          "product-card-color-swatches__more";

        moreButton.textContent =
          "+" + hiddenItems.length;

        moreButton.setAttribute(
          "aria-expanded",
          "false"
        );

        moreButton.addEventListener(
          "click",
          function (event) {
            event.preventDefault();
            event.stopPropagation();

            var isOpen =
              list.classList.toggle("is-expanded");

            hiddenItems.forEach(function (item) {
              item.classList.toggle(
                "is-hidden-swatch",
                !isOpen
              );
            });

            moreButton.textContent = isOpen
              ? "−"
              : "+" + hiddenItems.length;

            moreButton.setAttribute(
              "aria-expanded",
              String(isOpen)
            );
          }
        );

        moreItem.appendChild(moreButton);
        list.appendChild(moreItem);
      });
  }

  /*
 * Conserva i conteggi completi dei colori presenti
 * prima che Shopify restringa la griglia a un colore.
 */
var annabFullColorCounts =
  window.annabFullColorCounts || {};

window.annabFullColorCounts =
  annabFullColorCounts;

function updateColorFacetCounts(
  selectedSize,
  selectedColors
) {
  var colorInputs = document.querySelectorAll(
    'input[name^="filter."][name*="colore"],' +
    'input[name^="filter."][name*="color"]'
  );

  /*
   * Prima di applicare un colore o una taglia,
   * salviamo i conteggi completi forniti da Shopify.
   */
  if (
    !selectedSize &&
    (!selectedColors || !selectedColors.length)
  ) {
    colorInputs.forEach(function (input) {
      var label = input.closest("label");
      if (!label) return;

      var textElement =
        label.querySelector(".facet-label-text") ||
        label.querySelector(
          ".checkbox__label-text"
        ) ||
        label.querySelector("span:last-child");

      if (!textElement) return;

      var fullText =
        textElement.textContent.trim();

      var match =
        fullText.match(/\((\d+)\)\s*$/);

      var cleanText = fullText
        .replace(/\(\d+\)\s*$/, "")
        .trim();

      var colorKey =
        normalize(cleanText);

      if (
        match &&
        colorKey &&
        typeof annabFullColorCounts[
          colorKey
        ] === "undefined"
      ) {
        annabFullColorCounts[colorKey] =
          parseInt(match[1], 10);
      }
    });
  }

  /*
   * Se non è selezionata alcuna taglia,
   * ripristiniamo sempre i conteggi completi.
   *
   * In questo modo, selezionando Flamingo,
   * Black Leopard continuerà a mostrare 4
   * invece di diventare 0.
   */
  if (!selectedSize) {
    colorInputs.forEach(function (input) {
      var label = input.closest("label");
      if (!label) return;

      var textElement =
        label.querySelector(".facet-label-text") ||
        label.querySelector(
          ".checkbox__label-text"
        ) ||
        label.querySelector("span:last-child");

      if (!textElement) return;

      var cleanText =
        textElement.textContent
          .replace(/\(\d+\)\s*$/, "")
          .trim();

      var colorKey =
        normalize(cleanText);

      var savedCount =
        annabFullColorCounts[colorKey];

      if (
        typeof savedCount !== "undefined"
      ) {
        textElement.textContent =
          cleanText +
          " (" +
          savedCount +
          ")";
      }
    });

    return;
  }

  /*
   * Se è selezionata una taglia,
   * calcoliamo il numero reale di prodotti
   * disponibili per ogni colore in quella taglia.
   */
  colorInputs.forEach(function (input) {
    var label = input.closest("label");
    if (!label) return;

    var textElement =
      label.querySelector(".facet-label-text") ||
      label.querySelector(
        ".checkbox__label-text"
      ) ||
      label.querySelector("span:last-child");

    if (!textElement) return;

    var cleanText =
      textElement.textContent
        .replace(/\(\d+\)\s*$/, "")
        .trim();

    var facetColor =
      normalize(cleanText);

    var productIds = new Set();

    document
      .querySelectorAll(".product-card")
      .forEach(function (card) {
        var productData =
          getProductData(card);

        if (
          !productData ||
          !Array.isArray(
            productData.option_names
          ) ||
          !Array.isArray(
            productData.variants
          )
        ) {
          return;
        }

        var indexes =
          getOptionIndexes(productData);

        var hasAvailableVariant =
          productData.variants.some(
            function (variant) {
              if (!variant.available) {
                return false;
              }

              var variantSize =
                indexes.size !== -1
                  ? normalize(
                      variant.options[
                        indexes.size
                      ]
                    )
                  : "";

              var variantColor =
                indexes.color !== -1
                  ? normalize(
                      variant.options[
                        indexes.color
                      ]
                    )
                  : "";

              return (
                indexes.size !== -1 &&
                indexes.color !== -1 &&
                variantSize ===
                  selectedSize &&
                variantColor ===
                  facetColor
              );
            }
          );

        if (hasAvailableVariant) {
          productIds.add(
            card.dataset.productId ||
            card.getAttribute(
              "data-product-id"
            )
          );
        }
      });

    textElement.textContent =
      cleanText +
      " (" +
      productIds.size +
      ")";
  });
}

  function updateRealResultsCount() {
  var visibleProductIds = new Set();

  document
    .querySelectorAll(".product-card")
    .forEach(function (card) {
      var wrapper =
        card.closest(".resource-list__item") ||
        card.closest(".product-grid__item") ||
        card.closest("li") ||
        card;

      var isHidden =
        wrapper.classList.contains(
          "is-hidden-by-color-size"
        ) ||
        window.getComputedStyle(wrapper).display ===
          "none";

      if (isHidden) return;

      var productId =
        card.dataset.productId ||
        card.getAttribute("data-product-id");

      /*
       * Evita di contare due volte lo stesso prodotto
       * nel caso Horizon duplichi qualche elemento.
       */
      visibleProductIds.add(
        productId || card
      );
    });

  var realCount = visibleProductIds.size;

  document
    .querySelectorAll(".facets__see-results")
    .forEach(function (button) {
      button.textContent =
        "VEDI " +
        realCount +
        " " +
        (realCount === 1
          ? "ARTICOLO"
          : "ARTICOLI");

      button.setAttribute(
        "data-real-results-count",
        String(realCount)
      );
    });
}

var annabStaticSwatchesInitialized = false;

function hasAnnaBFacetContext() {
  return Boolean(
    document.querySelector('input[name^="filter."]') ||
    document.querySelector('facet-filters-form') ||
    document.querySelector('.facets')
  );
}

function initStaticSwatchesOnce() {
  if (annabStaticSwatchesInitialized) return;

  annabStaticSwatchesInitialized = true;
  refreshSwatchMore();
}

function applyPinsFilter() {

  /*
   * Home, recommendations e altre sezioni con product card
   * non hanno i filtri della Collection.
   *
   * In queste pagine inizializziamo solo gli swatch
   * senza analizzare tutte le varianti di tutte le card.
   */
  if (!hasAnnaBFacetContext()) {
    initStaticSwatchesOnce();
    return;
  }
    var filters = getFilters();
    var selectedSize = filters.size;
    var selectedColors = filters.colors;

    document
      .querySelectorAll(".product-card")
      .forEach(function (card) {
        var wrapper =
          card.closest(".resource-list__item") ||
          card.closest("li") ||
          card;

        var productData = getProductData(card);

        if (
          !productData ||
          !Array.isArray(
            productData.option_names
          ) ||
          !Array.isArray(productData.variants)
        ) {
          /*
           * Se non possiamo leggere le varianti e c'è
           * un filtro attivo, nascondiamo la card invece
           * di mostrare un falso disponibile.
           */
          wrapper.classList.toggle(
            "is-hidden-by-color-size",
            Boolean(
              selectedSize ||
              selectedColors.length
            )
          );

          return;
        }

        var indexes =
          getOptionIndexes(productData);

        /*
         * Tutte e sole le varianti realmente disponibili
         * nella taglia selezionata.
         */
        var variantsForSelectedSize =
          productData.variants.filter(
            function (variant) {
              if (!variant.available) {
                return false;
              }

              var variantSize =
                indexes.size !== -1
                  ? normalize(
                      variant.options[
                        indexes.size
                      ]
                    )
                  : "";

              return (
                !selectedSize ||
                (
                  indexes.size !== -1 &&
                  variantSize === selectedSize
                )
              );
            }
          );

        /*
         * Se è selezionato un colore, deve esistere
         * almeno una variante disponibile con:
         * TAGLIA + UNO DEI COLORI selezionati.
         */
        var matchingVariants =
          variantsForSelectedSize.filter(
            function (variant) {
              if (!selectedColors.length) {
                return true;
              }

              if (indexes.color === -1) {
                return false;
              }

              var variantColor = normalize(
                variant.options[indexes.color]
              );

              return selectedColors.includes(
                variantColor
              );
            }
          );

        /*
         * Il prodotto è visibile soltanto se esiste
         * una variante realmente disponibile che
         * rispetta tutti i filtri.
         */
        var productAvailable =
          matchingVariants.length > 0;

        wrapper.classList.toggle(
          "is-hidden-by-color-size",
          Boolean(
            (
              selectedSize ||
              selectedColors.length
            ) &&
            !productAvailable
          )
        );

        if (
          (
            selectedSize ||
            selectedColors.length
          ) &&
          !productAvailable
        ) {
          return;
        }

        var availableSwatches = [];

        card
          .querySelectorAll(".js-color-swatch")
          .forEach(function (swatch) {
            var item = swatch.closest(
              ".product-card-color-swatches__item"
            );

            if (!item) return;

            var swatchColor = normalize(
              swatch.getAttribute(
                "data-color-handle"
              ) ||
              swatch.getAttribute(
                "data-color-value"
              ) ||
              swatch.getAttribute(
                "data-color-name"
              )
            );

            /*
             * Cerca la variante esatta del colore
             * nella taglia selezionata.
             */
            var exactVariant =
              variantsForSelectedSize.find(
                function (variant) {
                  if (indexes.color === -1) {
                    return false;
                  }

                  var variantColor = normalize(
                    variant.options[
                      indexes.color
                    ]
                  );

                  return (
                    variantColor === swatchColor
                  );
                }
              );

            /*
             * Con taglia selezionata:
             * mostra il pin solo se quel colore ha
             * davvero quella taglia disponibile.
             *
             * Con colore selezionato:
             * mostra soltanto i colori selezionati
             * che rispettano anche la taglia.
             */
            var swatchAvailable =
              Boolean(exactVariant);

            var swatchMatchesColor =
              !selectedColors.length ||
              selectedColors.includes(
                swatchColor
              );

            var mustHideSwatch = false;

            if (selectedSize) {
              mustHideSwatch =
                !swatchAvailable;
            }

            if (selectedColors.length) {
              mustHideSwatch =
                mustHideSwatch ||
                !swatchMatchesColor ||
                !swatchAvailable;
            }

            item.classList.toggle(
              "is-hidden-by-size",
              mustHideSwatch
            );

            if (mustHideSwatch) {
              swatch.classList.remove(
                "is-active"
              );

              return;
            }

            if (exactVariant) {
              setExactVariantUrl(
                swatch,
                exactVariant
              );
            }

            availableSwatches.push({
              swatch: swatch,
              color: swatchColor,
              variant: exactVariant
            });
          });

        /*
         * Mantiene il colore cliccato manualmente
         * soltanto se ancora disponibile.
         */
        var preferredSwatch = null;

        var currentColor = normalize(
          card.dataset.selectedColorValue || ""
        );

        if (currentColor) {
          preferredSwatch =
            availableSwatches.find(
              function (entry) {
                return (
                  entry.color === currentColor
                );
              }
            );
        }

        /*
         * In presenza del filtro colore, usa uno
         * dei colori selezionati.
         */
        if (
          !preferredSwatch &&
          selectedColors.length
        ) {
          preferredSwatch =
            availableSwatches.find(
              function (entry) {
                return selectedColors.includes(
                  entry.color
                );
              }
            );
        }

        /*
         * Altrimenti usa il primo colore disponibile
         * nella taglia scelta.
         */
        if (
          !preferredSwatch &&
          availableSwatches.length
        ) {
          preferredSwatch =
            availableSwatches[0];
        }

        if (preferredSwatch) {
  var activeSwatch = card.querySelector(
    ".js-color-swatch.is-active"
  );

  var activeItem = activeSwatch
    ? activeSwatch.closest(
        ".product-card-color-swatches__item"
      )
    : null;

  var activeStillAvailable =
    activeSwatch &&
    activeItem &&
    !activeItem.classList.contains(
      "is-hidden-by-size"
    );

  /*
   * Se il cliente ha cliccato manualmente un pin
   * e quel pin è ancora disponibile, non cambiamo
   * nuovamente immagine e colore.
   */
  if (
    card.dataset.manualColorSelection === "true" &&
    activeStillAvailable
  ) {
    return;
  }

            activateFilteredSwatch(
            card,
            preferredSwatch.swatch
          );
        }
      });

    updateColorFacetCounts(
  selectedSize,
  selectedColors
);
refreshSwatchMore();
updateRealResultsCount();
  }

  var runTimer = null;

  function scheduleRun(delay) {
    clearTimeout(runTimer);

    runTimer = setTimeout(
      applyPinsFilter,
      delay || 150
    );
  }

  var originalPushState =
    history.pushState;

  var originalReplaceState =
    history.replaceState;

  history.pushState = function () {
    originalPushState.apply(
      history,
      arguments
    );

    scheduleRun(150);
  };

  history.replaceState = function () {
    originalReplaceState.apply(
      history,
      arguments
    );

    scheduleRun(150);
  };

  document.addEventListener(
    "change",
    function (event) {
      if (
        event.target.matches(
          'input[name^="filter."]'
        )
      ) {
        scheduleRun(200);
      }
    }
  );

  function handleAnnaBSwatchInteraction(event) {
  var swatch = event.target.closest(
    ".js-color-swatch"
  );

  /*
   * Clic o pressione su un pin colore.
   */
  if (swatch) {
    var item = swatch.closest(
      ".product-card-color-swatches__item"
    );

    /*
     * Blocca i pin non disponibili
     * nella taglia selezionata.
     */
    if (
      item &&
      item.classList.contains(
        "is-hidden-by-size"
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    var card = swatch.closest(
      ".product-card"
    );

    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    /*
     * Memorizza il colore scelto manualmente,
     * così il filtro non lo sostituisce.
     */
    card.dataset.manualColorSelection = "true";

    activateFilteredSwatch(
      card,
      swatch
    );

    return;
  }

  /*
   * Il + e il − non devono rilanciare
   * il filtro o chiudere nuovamente i pin.
   */
  if (
    event.target.closest(
      ".product-card-color-swatches__more"
    )
  ) {
    return;
  }

  /*
   * Rilancia il filtro soltanto quando
   * si utilizza davvero un filtro Shopify.
   *
   * Questa parte viene eseguita solo sul click,
   * non sul pointerdown.
   */
  if (
    event.type === "click" &&
    event.target.closest(
      'label, input[name^="filter."], facet-remove, .active-facets__button'
    )
  ) {
    scheduleRun(350);
  }
}

/*
 * Intercetta il gesto prima del link trasparente
 * che ricopre la card Horizon.
 */
document.addEventListener(
  "pointerdown",
  function (event) {
    var swatch = event.target.closest(
      ".js-color-swatch"
    );

    var moreButton = event.target.closest(
      ".product-card-color-swatches__more"
    );

    if (swatch || moreButton) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  true
);

document.addEventListener(
  "click",
  handleAnnaBSwatchInteraction,
  true
);

  var grid =
    document.querySelector("#ResultsList") ||
    document.querySelector(
      ".main-collection-grid"
    ) ||
    document.querySelector(".product-grid") ||
    document.querySelector("[ref='grid']");

  if (grid) {
    var observerTimer = null;

    new MutationObserver(function (mutations) {
      var productsChanged = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(
          function (node) {
            if (
              !(node instanceof HTMLElement)
            ) {
              return;
            }

            if (
              node.matches(
                ".product-card, .resource-list__item"
              ) ||
              node.querySelector(
                ".product-card, .js-color-swatch"
              )
            ) {
              productsChanged = true;
            }
          }
        );
      });

      if (!productsChanged) return;

      clearTimeout(observerTimer);

      observerTimer = setTimeout(
        applyPinsFilter,
        200
      );
    }).observe(grid, {
      childList: true,
      subtree: true
    });
  }

  /*
 * Esecuzione iniziale.
 * Lo script è caricato con defer, quindi il DOM
 * è già disponibile quando viene eseguito.
 *
 * Se non ci sono filtri attivi nell'URL non c'è nulla
 * di urgente da nascondere: rimandiamo il lavoro a un
 * momento di inattività del main thread per non pesare
 * sul caricamento (TBT).
 */
if (!hasAnnaBFacetContext()) {
  /*
   * Pagine senza filtri (home, prodotto...): l'unico lavoro è aggiungere il
   * pulsante "+N" alle liste di colori. È poco costoso ma MODIFICA IL LAYOUT,
   * quindi va fatto subito: rimandandolo a idle le card crescevano dopo il
   * primo paint e spingevano in basso le sezioni successive (CLS).
   */
  applyPinsFilter();
} else if (
  window.location.search.indexOf("filter.") !== -1 ||
  !("requestIdleCallback" in window)
) {
  applyPinsFilter();
} else {
  /*
   * Solo qui il lavoro è pesante: analisi di tutte le varianti di tutte le
   * card. Restando in idle non pesa sul caricamento.
   */
  requestIdleCallback(applyPinsFilter, { timeout: 2000 });
}

/*
 * Aggiornamenti successivi realmente necessari.
 */
window.addEventListener(
  "popstate",
  applyPinsFilter
);

document.addEventListener(
  "shopify:section:load",
  applyPinsFilter
);
})();